/**
 * @file paddle Wave Summit 2020 Hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useCallback, useEffect, useState} from 'react';
import {fetchGetProjectSInfo, fetchGetWS2020Data} from '../../api/pages/waveSummitPlus2020Api';
import {IActivityListProps} from './components/active-list/types';
import {IAwardsCeremonyProps} from './components/awards-ceremony/types';
import {IProjectItem} from './components/open-source-project-table/types';

// 预请求
let preRequest: any = {
    fetchGetWS2020Data: fetchGetWS2020Data()
};

const useWaveSummitHooks = () => {
    const [introduce, setintroduce] = useState<string>('');
    const [activityParticipation, setActivityParticipation] = useState<IActivityListProps>({});
    const [awardsCeremony, setAwardsCeremony] = useState<IAwardsCeremonyProps>({});
    const [openSourceProjectList, setOpenSourceProjectList] = useState<IProjectItem[]>([]);
    const [participationRules, setParticipationRules] = useState<string>('');
    const [footerText, setFooterText] = useState<string>('');

    // 更新项目start数
    const setOpenSourceProjectStargazersCount = useCallback((key: string | number, count: string) => {
        setOpenSourceProjectList((old) => {
            const targetIndex = old.findIndex(i => i.key === key);
            if (targetIndex > -1) {
                const newList = old.slice(0);
                newList[targetIndex] = {
                    ...newList[targetIndex],
                    startNum: count
                };
                return newList;
            }
            return old;
        });
    }, [setOpenSourceProjectList]);

    useEffect(() => {
        (async () => {
            const res = await (preRequest.fetchGetWS2020Data || fetchGetWS2020Data())
                .catch(() => {
                    // ignore
                });
            delete preRequest.fetchGetWS2020Data;
            if (res) {
                const data = res.body.result.pageData || {};
                setintroduce(data.introduce?.introduce ?? '');

                const apm = data.activityParticipationMode || {};
                const apmList: any[] = Array.isArray(apm.list) ? apm.list : [];
                setActivityParticipation({
                    list: apmList.map((item) => ({
                        btnLink: item.btnLink,
                        btnText: item.btnText,
                        text: item.text,
                        title: item.title
                    })),
                    qrcode: apm.qrcode,
                    qrcodeLink: apm.qrcodeLink,
                    qrcodeTitle: apm.qrcodeTitle
                });

                const ac = data.awardsCeremony || {};
                const acExplainList: any[] = Array.isArray(ac.explainList) ? ac.explainList : [];
                const acPrize: any[] = Array.isArray(ac.prize) ? ac.prize : [];
                setAwardsCeremony({
                    explainList: acExplainList,
                    prize: acPrize.map((item) => ({
                        imageUrl: item.imageUrl,
                        link: item.link,
                        title: item.title
                    }))
                });

                const rules = data.rules?.rules ?? '';
                setParticipationRules(rules);

                const p = data.projects || {};
                const pList: any[] = Array.isArray(p.list) ? p.list : [];
                const spList: IProjectItem[] = pList.map((item) => ({
                    key: `${item.githubId}${item.repoName}`,
                    githubId: item.githubId,
                    link: item.link,
                    projectName: item.projectName,
                    startNum: item.startNum,
                    isTop: item.isTop,
                    repoName: item.repoName
                }));
                setOpenSourceProjectList(spList);

                spList.forEach(async (item) => {
                    if (!item.isTop && item.key && item.githubId && item.repoName) {
                        const res = await fetchGetProjectSInfo(item.githubId, item.repoName)
                            .catch(() => {
                                // ignore
                            });
                        if (res) {
                            const data = res.body || {};
                            const stargazersCount = `${data.stargazers_count || 0}`;
                            setOpenSourceProjectStargazersCount(item.key, stargazersCount);
                        }
                    }
                });

                const ft = data.footerText || {};
                setFooterText(ft.text || '');
            }
        })();
    }, [
        setintroduce,
        setActivityParticipation,
        setAwardsCeremony,
        setOpenSourceProjectList,
        setOpenSourceProjectStargazersCount,
        setParticipationRules,
        setFooterText
    ]);

    return {
        introduce,
        activityParticipation,
        awardsCeremony,
        openSourceProjectList,
        participationRules,
        footerText
    };
};

export default useWaveSummitHooks;
